import React from "react";
import { getMandatoryServiceCodeList } from "../../helpers/backend_helper";
import CodeList from "./CodeList";
import MandatoryServiceDetail from "./MandatoryServiceDetail";

const MustCoverList = ({ createRequest = 0 }) => (
  <CodeList
    createRequest={createRequest}
    listCodes={getMandatoryServiceCodeList}
    DetailComponent={MandatoryServiceDetail}
    codeLabel="Must Cover Code"
    codesLabel="Must Cover Codes"
    categoryLabel="PRIMA Must Cover Code"
    searchPlaceholder="Search must cover codes..."
    fileName="prima-must-cover-codes"
  />
);

export default MustCoverList;
